<template>
  <div class="container-fluid internas-header">
    <div class="container">
      <div class="navbar">
        <div class="logo">
          <router-link :to="homePath">
            <img style="padding:12px" src="../assets/logo.svg" />
          </router-link>
        </div>

        <div class="icos-header">
          <p v-if="username" class="welcome-text">
            Seja bem vindo(a) {{ username }}
          </p>

          <router-link v-if="!feedInventoryOnly" to="/home-page">
            <img src="../assets/ico-home.svg"/>
          </router-link>

          <a href="#" data-toggle="modal" data-target="#logoutModal">
            <img src="../assets/ico-log-out.svg" />
          </a>
        </div>
      </div>
    </div>

    <ModalStyle>
      <LogoutModal />
      <RegisterUserModal />
    </ModalStyle>
  </div>
</template>

<script>
import ModalStyle from "./ModalStyle.vue";
import LogoutModal from "./LogoutModal.vue";
import RegisterUserModal from "./RegisterUserModal.vue";
import { isFeedInventoryOnly } from "../utils/feedInventoryAccess";

export default {
  name: "Navbar",
  components: {
    ModalStyle,
    LogoutModal,
    RegisterUserModal
  },
  computed: {
    username() {
      const user = this.$store.getters.getCurrentUser;
      return user?.username || window.localStorage.getItem("username") || "";
    },
    feedInventoryOnly() {
      return isFeedInventoryOnly(
        this.$store.getters.getCurrentUser,
        this.$store.getters.getCompanySettings,
      )
    },
    homePath() {
      return this.feedInventoryOnly ? "/feed-inventory" : "/home-page"
    },
  },
};

</script>

<style scoped>
.container{
  width: 100%;
  display: flex;
  justify-content: center;
}

.internas-header {
  display: flex;
  justify-content: center;
  background: #6ca63c;
  padding: 10px 0 10px 0;
}

.logo {
  margin-bottom: 0;
  padding: 1px 0 0 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
}

.logo img {
  width: 180px;
}

.navbar {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
}

.icos-header {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.welcome-text {
  margin: 0 16px 0 0;
  color: #fff;
  font-weight: 300;
  font-size: 16px;
  white-space: nowrap;
}

.icos-header a {
  cursor: default;
  padding: 0 8px;
}

.icos-header img {
  cursor: pointer;
}

.infos-header .dropdown-menu {
  border: none;
  -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.22);
  -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.22);
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.22);
}

.infos-header .dropdown-item, .internas-header .dropdown-item {
  padding: 10px 25px 10px 20px;
  border-bottom: dotted 1px #CCC;
  font-weight: 400;
  color: #3E3E3E;
}

.infos-header .dropdown-item:last-child, .internas-header .dropdown-item:last-child {
  border-bottom: none;
}

@media screen and (max-width: 768px) {
  .welcome-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 360px) {
  .logo img {
    width: 156px;
  }

  .welcome-text {
    display: none;
  }
}

</style>
